import API_CALL from 'services/API';
import { iPaginationParams } from 'utils/helpers/lists_helpers';
import { UserModel } from 'services/Models/UserModel';
const path = '/auth';

export const ServiceAuth = {

  login: async ({ username, password }) => {
    return API_CALL({
      method: 'POST',
      url: '/auth/login',
      data: { username, password },
    });
  },

  signup: async (data: Partial<UserModel>) => {

    return API_CALL({
      method: 'POST',
      url: path + '/signup',
      data: data,
    });
  },

  changePassword: async ({ newpassword, token }) => {
    return API_CALL({
      method: 'POST',
      url: path + '/change-password',
      data: {
        newpassword,
        token,
      },
    });
  },

  resetPassword: async ({ email }) => {
    return API_CALL({
      method: 'POST',
      url: path + '/reset-password',
      data: {
        email: email,
      },
    });
  },

};
export default ServiceAuth;
